import { Layout } from 'antd';

import Sidebar from 'components/MainLayout/Sidebar';
import 'antd/dist/antd.min.css'
import Routes from 'components/Routes/Routes';
import { BrowserRouter as Router } from 'react-router-dom';
import MainHeader from 'components/MainLayout/MainHeader';
import MainPageHeader from 'components/MainLayout/MainPageHeader';

export default function AuthenticatedApp() {
    const { Header, Sider, Content } = Layout;

    return (
        <Router>
            <Layout style={{ minHeight: '100vh' }}>
                <Header style={{ backgroundColor: '#F0F0F0' }}><MainHeader /></Header>
                <Layout>
                    <Sider width={290} style={{ marginRight: '2px' }}><Sidebar /></Sider>
                    <Content style={{ backgroundColor: '#fff' }}><MainPageHeader/><Routes /></Content>
                </Layout>
            </Layout>
        </Router>
    )
}
